(function () {
  'use strict';

  var COLOR_KEYS = ['colour', 'color'];

  // --- Utilities ---

  function findColorFieldset() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return null;
    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;
      var text = legend.textContent.toLowerCase();
      for (var j = 0; j < COLOR_KEYS.length; j++) {
        if (text.indexOf(COLOR_KEYS[j]) !== -1) return fieldsets[i];
      }
    }
    return null;
  }

  function getKnownColors() {
    var fs = findColorFieldset();
    if (!fs) return [];
    return Array.prototype.slice
      .call(fs.querySelectorAll('input'))
      .map(function (inp) { return inp.value.trim().toLowerCase(); });
  }

  // Match alt text by its first dash-separated segment: "Sage - Front" → "sage"
  function altColor(alt, knownColors) {
    if (!alt) return null;
    var first = alt.split('-')[0].trim().toLowerCase();
    if (!first) return null;
    for (var i = 0; i < knownColors.length; i++) {
      if (first === knownColors[i]) return knownColors[i];
    }
    return null; // untagged → show for every colour
  }

  function isVisible(alt, selectedColor, knownColors) {
    var c = altColor(alt, knownColors);
    if (c === null) return true;           // untagged: always show
    if (!selectedColor) return false;      // tagged, nothing selected: hide
    return c === selectedColor;
  }

  function getImgAlt(el) {
    var img = el.querySelector('img');
    return img ? (img.getAttribute('alt') || '') : '';
  }

  // --- Resolve colour from variant:update sourceId ---

  function colorFromSourceId(sourceId) {
    if (!sourceId) return null;
    var el = document.querySelector('[data-option-value-id="' + sourceId + '"]');
    if (!el) return null;
    var fs = el.closest('fieldset');
    if (!fs) return null;
    var legend = fs.querySelector('legend');
    if (!legend) return null;
    var legendText = legend.textContent.toLowerCase();
    for (var j = 0; j < COLOR_KEYS.length; j++) {
      if (legendText.indexOf(COLOR_KEYS[j]) !== -1) {
        return el.value.trim().toLowerCase();
      }
    }
    return null;
  }

  function currentColor() {
    var fs = findColorFieldset();
    var checked = fs && fs.querySelector('input:checked');
    return checked ? checked.value.trim().toLowerCase() : null;
  }

  // --- Core filter ---
  // Re-evaluates every slide and thumbnail from scratch using display:none.
  // Never carries over previous state. Original on:click="/select/N" indices
  // are preserved; slideshow.select(N) uses the slide's live offsetLeft,
  // which correctly reflects the filtered flex layout.

  function applyFilter(selectedColor) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var knownColors = getKnownColors();

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('slideshow-slide'));
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('button.slideshow-controls__thumbnail')
    );

    slides.forEach(function (slide) {
      var alt = getImgAlt(slide);
      var show = isVisible(alt, selectedColor, knownColors);
      slide.style.display = show ? '' : 'none';
    });

    var firstThumb = true;
    thumbs.forEach(function (thumb, i) {
      var alt = getImgAlt(thumb);
      var show = isVisible(alt, selectedColor, knownColors);
      thumb.style.display = show ? '' : 'none';
      if (show) {
        thumb.setAttribute('aria-selected', firstThumb ? 'true' : 'false');
        firstThumb = false;
      } else {
        thumb.setAttribute('aria-selected', 'false');
      }
    });

    // Reset scroll to position 0. With display:none, visible slides pack to
    // the left in the flex container so scrollLeft=0 always shows the first one.
    var scroller = gallery.querySelector('slideshow-slides');
    if (scroller) scroller.scrollTo({ left: 0, behavior: 'instant' });
  }

  // --- Post-render bubble handler ---
  // variant:update bubbles from variant-picker through .shopify-section (where
  // media-gallery.js replaces the gallery) and on to document. By the time
  // this handler fires, the replacement gallery is already live in the DOM.

  document.addEventListener('variant:update', function (ev) {
    var detail = ev.detail;
    if (!detail) return;

    // sourceId = data-option-value-id of the clicked radio. Picker DOM is
    // still pre-morph here (updateVariantPicker runs after dispatchEvent returns).
    var color = colorFromSourceId(detail.sourceId) || currentColor();
    if (!color) return;

    applyFilter(color);
  }); // bubble phase (default) — fires after section-level handlers

  // --- Initial page-load ---

  function init() {
    requestAnimationFrame(function () {
      applyFilter(currentColor());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
